
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { InvoiceItem } from "@/types/invoice";

export const generateInvoicePDF = async (
  invoiceRef: React.RefObject<HTMLDivElement>,
  invoice: {
    invoice_number: string;
    items?: InvoiceItem[];
  }
) => {
  if (!invoiceRef.current) return;

  // Create a clone of the element to modify for PDF generation
  const element = invoiceRef.current.cloneNode(true) as HTMLElement;
  
  // Remove buttons, status badges, and empty description items from the clone
  const elementsToRemove = element.querySelectorAll('.pdf-exclude');
  elementsToRemove.forEach(el => el.remove());
  
  // Also remove the status badge
  const statusBadge = element.querySelector('.status-badge');
  if (statusBadge) {
    statusBadge.remove();
  }

  // Make the clone visible for html2canvas but positioned off-screen
  document.body.appendChild(element);
  element.style.position = 'absolute';
  element.style.left = '-9999px';
  element.style.top = '-9999px';
  element.style.width = '900px';  // Fixed width for proper rendering
  
  try {
    const canvas = await html2canvas(element, {
      scale: 2, // Higher scale for better quality
      useCORS: true,
      logging: false,
      allowTaint: true,
      backgroundColor: '#ffffff'
    });
    
    // Remove the clone after capturing
    document.body.removeChild(element);
    
    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: 'a4'
    });
    
    // Calculate dimensions
    const imgWidth = 210; // A4 width in mm (210mm)
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    
    pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
    pdf.save(`Invoice-${invoice.invoice_number}.pdf`);
  } catch (error) {
    console.error('Error generating PDF:', error);
    // Clean up in case of error
    if (document.body.contains(element)) {
      document.body.removeChild(element);
    }
  }
};
